import { defineComponent as _defineComponent } from 'vue'

import { defineComponent } from 'vue'
const __default__ = defineComponent({
  name: 'UIButtonLite',
  props: {
    icon: {
      type: String,
      default: 'plus'
    },
    label: {
      type: String,
      default: 'Button'
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  }
})

import ZIcon from '~/components/zeal/ZIcon/ZIcon.vue'

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return { __sfc: true,ZIcon }
}

})